import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import { App } from './App';
import { TeamsProvider } from './teams/TeamsProvider';
import { ErrorBoundary } from './components/ErrorBoundary';

// Two boundaries, deliberately: the outer one catches a failure in
// TeamsProvider itself (teams-js init, theme resolution) which would otherwise
// leave a blank iframe; the inner one keeps a page-level crash from taking the
// Fluent theme provider down with it. The outer boundary renders outside any
// FluentProvider, so ErrorBoundary brings its own (CLAUDE.md log entry 15) —
// both fallbacks render themed regardless of where in the tree they catch.
//
// HashRouter: Teams serves the tab from a fixed contentUrl, so hash-based
// routing avoids server-side route handling inside the Teams webview.
createRoot(document.querySelector('#root')!).render(
  <StrictMode>
    <ErrorBoundary area="app">
      <TeamsProvider>
        <HashRouter>
          <ErrorBoundary area="page">
            <App />
          </ErrorBoundary>
        </HashRouter>
      </TeamsProvider>
    </ErrorBoundary>
  </StrictMode>,
);
